export default function useCapitalise(val: string) {
  if (val) {
    return val[0].toUpperCase() + val.substr(1);
  }
  return val;
}
